import { render, staticRenderFns } from "./EmployeeEducationDetailSection.vue?vue&type=template&id=68c0853b&scoped=true&"
import script from "./EmployeeEducationDetailSection.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c0853b",
  null
  
)

export default component.exports